import React from 'react'
import styled from 'styled-components'
import { TitanTVLogo } from '../../Header/HeaderStyles'
import logo from '../../../img/TitanTV_Logo.png'

const FaqsHelpHeader = () => {
	return (
		<StyledFaqsHelpHeader>
			<TitanTVLogo src={logo} alt="Logo" />
		</StyledFaqsHelpHeader>
	)
}

export default FaqsHelpHeader

const StyledFaqsHelpHeader = styled.div`
	margin-bottom: 15px;
`